import type { JsonValue } from 'type-fest';

import { Text, Flex } from '@frontend/components';

import type {
  JobHistoryQuery,
  QuoteHistoryQuery,
  SimilarPartsQuery,
} from './types';

export const getIsSimilarPartsData = (
  similarPartsData: Blob | JsonValue | SimilarPartsQuery | undefined,
): similarPartsData is SimilarPartsQuery =>
  (similarPartsData as SimilarPartsQuery).length !== undefined;

export const getIsJobHistoryData = (
  jobHistoryData?: unknown,
): jobHistoryData is JobHistoryQuery =>
  jobHistoryData != null &&
  typeof jobHistoryData === 'object' &&
  'count' in jobHistoryData;

export const getIsQuoteHistoryData = (
  similarPartsData?: unknown,
): similarPartsData is QuoteHistoryQuery =>
  similarPartsData != null &&
  typeof similarPartsData === 'object' &&
  'count' in similarPartsData;

export const DisabledPartDescriptorTooltipLabel = ({
  action,
  isPartInSentQuote = false,
  isPartInTrashedQuote = false,
  isPartInMultipleQuoteItems = false,
  isFromPartLibrary = false,
  isAnotherPersonEditing = false,
}: {
  action: string;
  isPartInSentQuote?: boolean;
  isPartInTrashedQuote?: boolean;
  isPartInMultipleQuoteItems?: boolean;
  isFromPartLibrary?: boolean;
  isAnotherPersonEditing?: boolean;
}): JSX.Element => {
  const tooltipLabelReason: string = isAnotherPersonEditing
    ? ' because someone else is editing this part'
    : isPartInSentQuote
    ? ' because this part has been sent in a quote'
    : isPartInTrashedQuote
    ? ' because this part is in a trashed quote'
    : isPartInMultipleQuoteItems
    ? ' because this part is used in multiple quote items'
    : '';

  const tooltipLabelResolution = isAnotherPersonEditing
    ? 'To do so, take over editing.'
    : `To do so, replace the referenced part with a new version${
        isFromPartLibrary ? ' from a quote' : ''
      }.`;

  return (
    <Flex direction="column" alignItems="start" gap={2}>
      <Text color="inherit">{`You can't ${action}${tooltipLabelReason}.`}</Text>
      <Text color="inherit" fontWeight="heavy">
        {tooltipLabelResolution}
      </Text>
    </Flex>
  );
};
